<template>
  <ContentLayout
    :title="$t('label_essweb_siteType_list_title')"
    :addBtn="hasBtn('add-admin-site-type')"
    pad="0"
    @new="toNew"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :showSelect="showSelect"
        :height="$vuetify.breakpoint.height - 275"
        :totalCount="totalCount"
        @change="
          (page, perpage, callback) => {
            getList(page, perpage, callback);
          }
        "
      >
        <template v-slot:item.name="{ item }">
          <div
            class="table-title pb-1 pt-2"
            :title="$getCommonLangValue(item.site_type_name)"
          >
            {{ $getCommonLangValue(item.site_type_name) }}
          </div>
          <!-- <div
            class="text--secondary table-subtitle"
            :title="$getCommonLangValue(item.site_type_description)"
          >
            {{ $getCommonLangValue(item.site_type_description) }}
          </div> -->
        </template>
        <template v-slot:item.abbr="{ item }">
          <div class="table-title">
            {{ $getCommonLangValue(item.site_type_abbr) }}
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <tableListTools
            :uuid="item.uuid"
            :delBtn="hasBtn('delete-admin-site-type')"
            :editBtn="hasBtn('edit-admin-site-type')"
            :viewBtn="hasBtn('view-admin-site-type')"
            :title="$t('label_essweb_siteType_list_title')"
            @delete="toDelete"
            @edit="toEdit"
            @view="toEdit"
          />
        </template>
      </Tabler>
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "SiteType",
  computed: {},
  created() {
    this.getBtnPermissionList();
  },
  mounted() {
    this.getList(1, this.$tableSetting.perPageSize, null);
  },
  data() {
    return {
      search: "",
      showSelect: false,
      selected: [],
      totalCount: 0,
      headers: [
        {
          text: "label_essweb_siteType_list_siteTypeNameLabel",
          align: "start",
          sortable: false,
          value: "name",
          filter: (value, search, item) => {
            if (!this.search) return true;
            return (
              item.site_type_name
                .toString()
                .toLocaleUpperCase()
                .indexOf(this.search.toLocaleUpperCase()) != -1
            );
          },
        },
        {
          text: "label_essweb_siteType_list_siteTypeAbbrLabel",
          value: "abbr",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          sortable: false,
          align: "end",
        },
      ],
      desserts: [],
    };
  },
  methods: {
    getList: function (page, perpage, callback) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_site_type",
        url: "/site-type/get-site-type-list/",
        data: { cpage: page, pagesize: perpage },
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback() : null;
      });
    },
    toNew: function () {
      this.$toPage("/admin/site-type/add", {});
    },
    toDelete: function (id) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_site_type",
        url: "/site-type/delete-site-type-table/",
        data: { uuids: id.toString() },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_siteType_list_deleteSiteTypeSuccessLabel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== id);
      });
    },
    toEdit: function (uuid, action) {
      this.$toPage(
        (action == "edit"
          ? "/admin/site-type/edit/"
          : "/admin/site-type/detail/") + uuid
      );
    },
    toEditAll: function () {
      this.showSelect = !this.showSelect;
    },
  },
};
</script>
<style scoped></style>
